import { createAxiosInstance } from "./axiosInstance";
require("dotenv").config();
const adtopia_api_url = process.env.REACT_APP_ADTOPIA_TRACKING_API;
const adtopia_api_token = process.env.REACT_APP_ADTOPIA_TOKEN;

export const AdtopiaApi = createAxiosInstance({
   baseURL: adtopia_api_url,
  token: adtopia_api_token,
  timeout: 5000,
});